import "./GridCell.scss";
import { ReactNode } from "react";
import cn from "classnames";
interface GridCell {
  children: ReactNode;
  reverseOrderOn?: "mobile" | "desktop";
  startColsDesktopLarge?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  startColsDesktopMediumMin?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  startColsDesktop?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  startColsTablet?: 1 | 2 | 3 | 4 | 5 | 6;
  startColsMobile?: 1 | 2 | 3 | 4 | 5 | 6;
  spanColsDesktopLarge?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  spanColsDesktopMediumMin?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  spanColsDesktop?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  spanColsTablet?: 1 | 2 | 3 | 4 | 5 | 6;
  spanColsMobile?: 1 | 2 | 3 | 4 | 5 | 6;
  displayFlex?: boolean;
  mobileOrder?: undefined | -1;
  rowSpan?: number;
  gridRow?: undefined | "min-content" | "1fr" | 2;
  desktopOnly?: boolean;
  overflowHidden?: boolean;
}

const GridCell = ({
  children,
  reverseOrderOn,
  startColsDesktopLarge,
  startColsDesktopMediumMin,
  startColsDesktop,
  startColsTablet,
  startColsMobile,
  spanColsDesktopLarge,
  spanColsDesktopMediumMin,
  spanColsDesktop,
  spanColsTablet,
  spanColsMobile,
  displayFlex,
  mobileOrder,
  rowSpan,
  gridRow,
  desktopOnly,
  overflowHidden,
}: GridCell) => (
  <div
    className={cn(
      "grid-cell",
      reverseOrderOn && `grid-cell--reverse-order--${reverseOrderOn}`,
      `grid-cell--start-cols-desktop-large-${startColsDesktopLarge} grid-cell--start-cols-desktop-medium-min-${startColsDesktopMediumMin} grid-cell--start-cols-desktop-${startColsDesktop} grid-cell--start-cols-tablet-${startColsTablet} grid-cell--start-cols-mobile-${startColsMobile}`,
      `grid-cell--span-cols-desktop-large-${spanColsDesktopLarge} grid-cell--span-cols-desktop-medium-min-${spanColsDesktopMediumMin} grid-cell--span-cols-desktop-${spanColsDesktop} grid-cell--span-cols-tablet-${spanColsTablet} grid-cell--span-cols-mobile-${spanColsMobile}`,
      mobileOrder && `grid-cell--mobile-order_${mobileOrder}`,
      {
        "grid-cell--display-flex": displayFlex,
        "grid-cell--desktop-only": desktopOnly,
        "grid-cell--overflow-hidden": overflowHidden,
      },
    )}
    style={{ gridRowStart: rowSpan ? `span ${rowSpan}` : undefined, gridRow }}
  >
    {children}
  </div>
);

export default GridCell;
